module.exports = __webpack_public_path__ + "img/bg_game.df25ade4.jpg";